import { media, mediaMax } from "components/designV2/breakpoints";
import { PrimaryButton } from "components/designV2/buttons/primaryButton";
import { Spacing } from "components/designV2/constants";
import { Text } from "components/designV2/text/text";
import { ColorV2 } from "config/colors";
import { ReactComponent as PenIconSvg } from "images/icons/svg/v2/pen.svg";
import { ReactComponent as PictureIconSvg } from "images/icons/svg/v2/picture.svg";
import styled, { keyframes } from "styled-components";
import { SettingsV2PageTitle } from "../companySettingsV2.styled";

export const ProfileForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
`;

export const ProfilePageTitle = styled(SettingsV2PageTitle)``;

export const ProfileContentGrid = styled.div`
  display: grid;
  gap: 32px;
  grid-template-columns: 1fr;
  align-items: start;

  ${media.tablet} {
    grid-template-columns: 280px minmax(0, 1fr);
  }
`;

export const ProfileImagePanel = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.md}px;
  align-items: center;

  ${mediaMax.tablet} {
    align-items: flex-start;
  }
`;

export const ProfileSectionTitle = styled(Text).attrs({
  typography: "b2",
  color: ColorV2.Blue4,
})`
  align-self: stretch;
  margin: 0;
`;

export const ProfileImageRow = styled.div`
  position: relative;
  display: inline-flex;
  align-items: flex-end;
  justify-content: center;
`;

export const ProfileImageSurface = styled.div`
  width: 160px;
  height: 160px;
  min-width: 160px;
  min-height: 160px;
  border-radius: 999px;
  background: ${ColorV2.Blue7};
  border: 1.5px solid ${ColorV2.Blue6};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const LoadingCircle = styled(ProfileImageSurface)`
  color: ${ColorV2.Blue1};
`;

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const LoadingSpinner = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  animation: ${spin} 0.9s linear infinite;
`;

export const ProfileAvatarImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 999px;
`;

export const ProfileAvatarPlaceholder = styled(PictureIconSvg)`
  width: 52px;
  height: 52px;
  color: ${ColorV2.Blue4};
`;

export const ProfileImageButtonIcon = styled(PenIconSvg)`
  width: 18px;
  height: 18px;
  color: ${ColorV2.White};

  path {
    fill: currentColor;
  }
`;

export const ProfileImageButton = styled.button`
  position: absolute;
  right: -4px;
  bottom: -4px;
  width: 48px;
  height: 48px;
  border-radius: 999px;
  border: 4px solid ${ColorV2.White};
  background: ${ColorV2.Blue1};
  color: ${ColorV2.White};
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: background-color 0.2s ease;

  &:hover {
    background: ${ColorV2.Blue2};
  }

  &:active {
    background: ${ColorV2.Blue3};
  }

  &:disabled {
    background: ${ColorV2.Blue5};
    cursor: not-allowed;
  }
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

export const ProfileUploadButton = styled(PrimaryButton)`
  align-self: center;

  ${mediaMax.tablet} {
    align-self: flex-start;
  }
`;

export const ErrorText = styled(Text).attrs({
  typography: "s1",
  color: ColorV2.NegativeRed,
})`
  margin: 0;
`;

export const ProfileFieldStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  width: 100%;
  max-width: 760px;
`;

export const ProfileActions = styled.div`
  display: flex;
  justify-content: center;
  padding-top: ${Spacing.sm}px;
`;
